import type { AttachmentsStoreSlice, SliceType } from '@ContractBuilder/store';
import { getSortedEntries } from '@root/helpers/layout/get-sorted-entries';

export const createAttachmentsSlice: SliceType<AttachmentsStoreSlice> = (set, get) => ({
  attachments: [],
  reloadAttachments: () => {
    const submission = get().submission;

    set({
      attachments: getSortedEntries(
        submission?.attachments_layout ?? [],
        submission?.attachments?.filter((attachment) => attachment?.block_id === undefined) ?? [],
      ),
    });
  },
});
